import axios from "axios";



export const logoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/'; // Redirect to login page
};

  


const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API}`,
    withCredentials: true
});


axiosInstance.interceptors.request.use(request => {
    const accessToken = localStorage.getItem('token');
    if (accessToken) {
        request.headers['Authorization'] = `Bearer ${accessToken}`;
    }
        return request;
    }, error => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use((response) => response, 
    async (error) => {


        console.log(error)
        const originalRequest = error.config;

        try{
            
            if (error.response?.status === 401  && !originalRequest._retry) {
                originalRequest._retry = true;

                const refreshToken = localStorage.getItem("refresh_token");

                if(refreshToken){
    
                    const res = await axios.post(`${process.env.REACT_APP_API}/auth/refresh-token`, {
                        refreshToken: refreshToken
                    })
                    const newToken = res.data.access_token;
                    const refreshtoken = res.data.refresh_token;
    
    
                    localStorage.setItem("token" , newToken)
                    localStorage.setItem("refresh_token" , refreshtoken)
    
                    // originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
                    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
                    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
    
    
                    return axiosInstance(originalRequest);
    
                }
                else{

                    logoutUser()

                }
                
            }


        }

        catch (error) {
            console.error("Error refreshing access token:", error);
            logoutUser()
            return null;
        }

       return Promise.reject(error);
    }
);
export default axiosInstance;
